import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

import { TwcModule } from '@topcon/twc-angular';

import { DirectivesModule } from '../../directives/directives.module';
import { ListSelectionModule } from '../list-selection/list-selection.module';
import { SphereRadiusChipsModule } from '../sphere-radius-chips';
import { ScanProcessingOptionsComponent } from './scan-processing-options.component';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        TwcModule,
        TranslateModule.forChild({
            extend: true,
        }),
        DirectivesModule,
        ListSelectionModule,
        SphereRadiusChipsModule,
    ],
    exports: [ScanProcessingOptionsComponent],
    declarations: [ScanProcessingOptionsComponent],
})
export class ScanProcessingOptionsModule {}
